import { render } from "./body_main_banner8.vue?vue&type=template&id=25d7991c&scoped=true"
import script from "./body_main_banner8.vue?vue&type=script&lang=js"
export * from "./body_main_banner8.vue?vue&type=script&lang=js"

import "./body_main_banner8.vue?vue&type=style&index=0&id=25d7991c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d7991c"]])

export default __exports__